import { render, staticRenderFns } from "./erasmus-mc.vue?vue&type=template&id=37b44645&"
import script from "./erasmus-mc.vue?vue&type=script&lang=js&"
export * from "./erasmus-mc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CaseIntro: require('/app/components/case/intro.vue').default,CaseVideo: require('/app/components/case/video.vue').default,CaseContent: require('/app/components/case/content.vue').default,CaseCta: require('/app/components/case/cta.vue').default})
